import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AppleDeviceProfileEffects } from './apple-device-profile.effects';
import { APPLE_DEVICE_PROFILE_FEATURE_KEY, appleDeviceProfileReducer } from './apple-device-profile.reducer';

export const provideAppleDeviceProfileStore = () => [
  provideState(APPLE_DEVICE_PROFILE_FEATURE_KEY, appleDeviceProfileReducer),
  provideEffects([AppleDeviceProfileEffects]),
];
